import GameSceneImage from '../../Inamove/Components/GameSceneImage/GameSceneImage'
import { createInteractableObjectListener } from '../../Inamove/Components/InteractableObject'
import { createTakeableObjectListener } from '../../Inamove/Components/TakeableObject'
import Video from '../../Inamove/Components/Video/Video'
import { waypointOpenActionCreator } from '../../Inamove/Components/Waypoint'
import CinematicContainer from '../../Inamove/Containers/CinematicContainer/CinematicContainer'
import Config from '../../Inamove/Containers/Config'
import GameSceneContainer from '../../Inamove/Containers/GameSceneContainer/GameSceneContainer'
import InventoryContainer from '../../Inamove/Containers/InventoryContainer/InventoryContainer'
import LoadingContainer from '../../Inamove/Containers/LoadingContainer/LoadingContainer'
import AudioController from '../../Inamove/Controllers/AudioController'
import LevelController from '../../Inamove/Controllers/LevelController'
import LoadingController from '../../Inamove/Controllers/LoadingController'
import dispatch from '../../Inamove/Utility/dispatchAction'

export default async function () {
    InventoryContainer.clean()
    CinematicContainer.hide()
    GameSceneContainer.hide()
    LoadingController.reset()
    LoadingContainer.show()

    const level = await LevelController.loadLevel('level5')

    // Videos
    const V9 = new Video(Config.CINEMATIC_PATH + 'V9' + Config.VIDEO_FILE_EXT)
    const K24_stecker_reinstecken_CINEMATIC = new Video(
        Config.GAME_SCENE_PATH + '/K24/video/K24-stecker-reinstecken' + Config.VIDEO_FILE_EXT
    )
    const K23_RechnerSchuetteln_CINEMATIC = new Video(
        Config.GAME_SCENE_PATH + '/K23/video/K23-RechnerSchuetteln' + Config.VIDEO_FILE_EXT
    )
    const K26_winStartet_black_CINEMATIC = new Video(
        Config.GAME_SCENE_PATH + '/K26/video/K26-winStartet-black' + Config.VIDEO_FILE_EXT
    )
    const K26_win_shutDOWN_CINEMATIC = new Video(
        Config.GAME_SCENE_PATH + '/K26/video/K26-win-shutDOWN' + Config.VIDEO_FILE_EXT
    )
    const K22_rechner_kaputt_CINEMATIC = new Video(
        Config.GAME_SCENE_PATH + '/K22/audio/rechner-kaputt' + Config.AUDIO_FILE_EXT
    )
    const V10_CINEMATIC = new Video(Config.CINEMATIC_PATH + 'V10' + Config.VIDEO_FILE_EXT)
    const V11_CINEMATIC = new Video(Config.CINEMATIC_PATH + 'V11' + Config.VIDEO_FILE_EXT)

    ;[
        V9,
        K24_stecker_reinstecken_CINEMATIC,
        K23_RechnerSchuetteln_CINEMATIC,
        K26_winStartet_black_CINEMATIC,
        K26_win_shutDOWN_CINEMATIC,
        K22_rechner_kaputt_CINEMATIC,
        V10_CINEMATIC,
        V11_CINEMATIC,
    ].forEach(LoadingController.addToQueue)

    let steckerDrin = false
    let pcGewackelt = false

    const activatePc = () => {
        if (steckerDrin && pcGewackelt) {
            // show power button that works
            level.gameScenes.K23.hideInteractableObject('hauptschalter')
            level.gameScenes.K23.showInteractableObject('hauptschalter1')
        }
    }

    // Stecker reinstecken
    const steckerDrinImage = new GameSceneImage(Config.GAME_SCENE_PATH + 'K24/K24-stecker.png')
    LoadingController.addToQueue(steckerDrinImage)
    level.gameScenes.K24.hideInteractableObject('steckdose1')

    createInteractableObjectListener('stromkabel', async () => {
        CinematicContainer.setVideo(K24_stecker_reinstecken_CINEMATIC)
        CinematicContainer.show()
        GameSceneContainer.hide()
        level.gameScenes.K24.addImage(steckerDrinImage)
        level.gameScenes.K24.removeInteractableObject('steckdose')
        level.gameScenes.K24.removeInteractableObject('stromkabel')
        level.gameScenes.K24.showInteractableObject('steckdose1')
        AudioController.setMute(true)
        await CinematicContainer.play()
        AudioController.setMute(false)
        GameSceneContainer.show()
        CinematicContainer.hide()
        steckerDrin = true
        activatePc()
    })

    // Mülleimer
    const K18I17Overlay = new GameSceneImage(Config.GAME_SCENE_PATH + 'K18/K18-I17.png')
    LoadingController.addToQueue(K18I17Overlay)
    level.gameScenes.K18.addImage(K18I17Overlay)

    const K21I17Overlay = new GameSceneImage(Config.GAME_SCENE_PATH + 'K21/K21-I17.png')
    LoadingController.addToQueue(K21I17Overlay)
    level.gameScenes.K21.addImage(K21I17Overlay)

    createTakeableObjectListener('mülleimer', () => {
        level.gameScenes.K18.removeImage(K18I17Overlay)
        level.gameScenes.K21.removeImage(K21I17Overlay)
        level.gameScenes.K18.hideWaypoint('K21')
    })

    // Schwein
    const SchweinOverlay = new GameSceneImage(Config.GAME_SCENE_PATH + 'K22/K22-Schwein-mitGrading.png')
    LoadingController.addToQueue(SchweinOverlay)
    level.gameScenes.K22.addImage(SchweinOverlay)

    // whiteboard
    // K18
    const visitenkarteImage = new GameSceneImage(Config.GAME_SCENE_PATH + 'K18/K18-visitenkarte.png')
    const notizzettelImage = new GameSceneImage(Config.GAME_SCENE_PATH + 'K18/K18-notizzettel.png')
    const nichtWackelnImage = new GameSceneImage(Config.GAME_SCENE_PATH + 'K18/K18-nicht-wackeln.png')
    const pizzaflyerImage = new GameSceneImage(Config.GAME_SCENE_PATH + 'K18/K18-I19-pizzafleyer.png')

    ;[visitenkarteImage, notizzettelImage, nichtWackelnImage, pizzaflyerImage].map(LoadingController.addToQueue)
    ;[visitenkarteImage, notizzettelImage, nichtWackelnImage, pizzaflyerImage].forEach(level.gameScenes.K18.addImage)

    // Notiz PC-Wackelkontakt
    level.gameScenes.K23.hideInteractableObject('hauptschalter1')
    level.gameScenes.K23.hideInteractableObject('hauptschalter2')
    level.gameScenes.K23.hideInteractableObject('hauptschalter3')
    level.gameScenes.K23.hideInteractableObject('spuren1')

    const NotizOverlay = new GameSceneImage(Config.GAME_SCENE_PATH + 'K20/K20-NotizWackeln.png')
    LoadingController.addToQueue(NotizOverlay)
    level.gameScenes.K20.addImage(NotizOverlay)

    createInteractableObjectListener(
        'notizwackeln',
        () => {
            level.gameScenes.K23.hideInteractableObject('spuren')
            level.gameScenes.K23.showInteractableObject('spuren1')
        },
        true
    )

    createTakeableObjectListener('notizpasswort', () => {
        notizzettelImage.hide()
    })

    createTakeableObjectListener('flyerpizza', () => {
        pizzaflyerImage.hide()
    })

    createTakeableObjectListener('visitenkarte', () => {
        visitenkarteImage.hide()
    })

    createInteractableObjectListener(
        'spuren1',
        async () => {
            // show pc wackeln video
            CinematicContainer.setVideo(K23_RechnerSchuetteln_CINEMATIC)
            CinematicContainer.show()
            GameSceneContainer.hide()
            AudioController.setMute(true)
            await CinematicContainer.play()
            AudioController.setMute(false)
            GameSceneContainer.show()
            CinematicContainer.hide()
            pcGewackelt = true
            activatePc()
        },
        true
    )

    // login screen
    const addLogin = () => {
        const loginText = document.createElement('p')
        loginText.classList.add('K26-login-text')
        loginText.innerHTML = 'Anmelden'

        const login = document.createElement('input')
        login.classList.add('K26-login')
        login.type = 'text'
        login.maxLength = 20

        login.onkeypress = async function (e) {
            login.classList.remove('error')

            // enter
            if (e.code === 'Enter') {
                if (login.value === 'X12KP?§') {
                    login.classList.add('hidden')
                    loginText.classList.add('hidden')
                    // when login is successful a notification is shown that there is a new message on the AB
                    // play video of pc crashing
                    CinematicContainer.setVideo(K26_win_shutDOWN_CINEMATIC)
                    CinematicContainer.show()
                    GameSceneContainer.hide()
                    AudioController.setMute(true)
                    await CinematicContainer.play()
                    AudioController.setMute(false)
                    level.changeGameScene('K22')
                    GameSceneContainer.show()
                    CinematicContainer.hide()

                    AudioController.play(rechnerKaputtAudio)
                    // telefon scene is now accessible
                    dispatch(waypointOpenActionCreator('K19'))
                    // switch hauptschalter
                    level.gameScenes.K23.hideInteractableObject('hauptschalter3')
                    level.gameScenes.K23.showInteractableObject('hauptschalter2')
                    // switch bildschirm hotspots
                    level.gameScenes.K22.hideWaypoint('K26')
                    level.gameScenes.K22.showInteractableObject('bildschirm')
                } else {
                    login.classList.add('error')
                    let animationCount = 0
                    const animation = setInterval(function () {
                        login.classList.toggle('error-blink')
                        if (++animationCount === 4) {
                            clearInterval(animation)
                        }
                    }, 100)
                    login.value = ''
                }
            }
        }

        function focusLogin() {
            login.focus()
        }

        login.onload = focusLogin
        login.onblur = focusLogin

        level.gameScenes.K26.element.appendChild(login)
        level.gameScenes.K26.element.appendChild(loginText)
        focusLogin()
    }

    createInteractableObjectListener(
        'hauptschalter1',
        async () => {
            level.gameScenes.K23.hideInteractableObject('hauptschalter1')
            level.gameScenes.K23.showInteractableObject('hauptschalter3')
            CinematicContainer.setVideo(V10_CINEMATIC)
            CinematicContainer.show()
            GameSceneContainer.hide()
            AudioController.setMute(true)
            await CinematicContainer.play()
            // starte rechner
            CinematicContainer.setVideo(K26_winStartet_black_CINEMATIC)
            await CinematicContainer.play()
            AudioController.setMute(false)
            level.changeGameScene('K26')
            GameSceneContainer.show()
            CinematicContainer.hide()

            addLogin()

            level.gameScenes.K22.hideInteractableObject('bildschirm')
            level.gameScenes.K22.showWaypoint('K26')
            level.gameScenes.K26.showWaypoint('K22')
        },
        true
    )

    level.gameScenes.K22.hideWaypoint('K26')

    const rechnerKaputtAudio = AudioController.add(
        Config.GAME_SCENE_PATH + 'K22/audio/rechner-kaputt' + Config.AUDIO_FILE_EXT
    )

    await AudioController.addAllToLoadingQueue()

    await LoadingController.processQueue()
    await LoadingContainer.clickStart()

    CinematicContainer.setVideo(V9)

    GameSceneContainer.hide()
    InventoryContainer.hide()
    CinematicContainer.show()
    LoadingContainer.hide()

    await CinematicContainer.play()

    CinematicContainer.hide()
    GameSceneContainer.show()
    LevelController.startLevel('level5')

    return new Promise<void>((resolve) => {
        createInteractableObjectListener(
            'telefon1',
            async () => {
                CinematicContainer.setVideo(V11_CINEMATIC)
                CinematicContainer.show()
                GameSceneContainer.hide()
                level.stop()
                await CinematicContainer.play()

                resolve()
                level.destroy()
            },
            true
        )
    })
}
